import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Avatar from 'components/common/Avatar';
import Input from 'components/common/Input';
import Flex from 'components/common/Flex';
import { Col, Collapse, Image, Row } from 'react-bootstrap';
/* import { useForm } from 'react-hook-form'; */
import { contextPayment } from 'context';
const initialsData = [
 {
  value: '1059',
  label: 'BANCAMIA S.A.',
  src: 'https://www.pse.com.co/documents/1176700/1193867/2-Bancamia.jpg/4c6c1f5a-49bd-7b61-b64c-be856a3a3b34?t=1597804883427'
 },
 {
  value: '1040',
  label: 'BANCO AGRARIO',
  src: 'https://www.pse.com.co/documents/1176700/1193867/3-Banco-Agrario.png/fac0f66b-b08a-4bad-57f0-a1a150cae54b?t=1597804883479'
 },
 {
  value: '1052',
  label: 'BANCO AV VILLAS',
  src: 'https://www.pse.com.co/documents/1176700/1193867/4+-Av+villas.jpg/0d6f71d8-2e18-f337-954d-cea23d2cf3c2?t=1597804883532'
 },
 {
  value: '1013',
  label: 'BANCO BBVA COLOMBIA S.A.',
  src: 'https://www.pse.com.co/documents/1176700/1193867/5-Banco-BBVA.png/8dc2b943-335e-cefc-8a8a-6578b13a8c4b?t=1597804883587'
 },
 {
  value: '1032',
  label: 'BANCO CAJA SOCIAL',
  src: 'https://www.pse.com.co/documents/1176700/1193867/6--Banco-Caja-Social.png/e1a0f88a-62aa-4ccd-557d-3557c2e6b631?t=1597804883646'
 },
 {
  value: '1066',
  label: 'BANCO COOPERATIVO COOPCENTRAL',
  src: 'https://www.pse.com.co/documents/1176700/1193867/7-Banco-Coopcentral.png/f56ba472-12c3-5421-7db1-086b4fc5d2c7?t=1597804883704'
 },
 {
  value: '1558',
  label: 'BANCO CREDIFINANCIERA',
  src: '/sites/all/themes/custom/credifinanciera/logo.svg'
 },
 {
  value: '1051',
  label: 'BANCO DAVIVIENDA',
  src: 'https://www.pse.com.co/documents/1176700/1193867/24-Davivienda.png/92432f89-8d34-9696-7c09-155398b5dd3f?t=1597804884457'
 },
 {
  value: '1001',
  label: 'BANCO DE BOGOTA',
  src: 'https://www.pse.com.co/documents/1176700/1193867/8-Banco-de-Bogota.png/d0f7b502-33ce-2708-f1b9-74f208493b8f?t=1597804883753'
 },
 {
  value: '1023',
  label: 'BANCO DE OCCIDENTE',
  src: 'https://www.pse.com.co/documents/1176700/1193867/9-Banco-de-Occidente.png/13b67926-c15a-af1d-0fc8-4755db30b763?t=1597804883805'
 },
 {
  value: '1062',
  label: 'BANCO FALABELLA',
  src: 'https://www.pse.com.co/documents/1176700/1193867/10-Banco-Falabella.png/edabf5d1-97f4-48f0-c586-aec2de9dcaf8?t=1597804883861'
 },
 {
  value: '1012',
  label: 'BANCO GNB SUDAMERIS',
  src: 'https://www.pse.com.co/documents/1176700/1193867/12-Banco-GNB-Sudameris.png/3b48f519-f31c-c22d-97ff-ffd91a07bd96?t=1597804883911'
 },
 {
  value: '1006',
  label: 'BANCO ITAU',
  src: 'https://www.pse.com.co/documents/1176700/1193867/13-Itau.png/8324bbb0-86e4-167f-baf4-22a623589528?t=1597804883967'
 },
 {
  value: '1060',
  label: 'BANCO PICHINCHA S.A.',
  src: 'https://www.pse.com.co/documents/1176700/1193867/14-Banco-Pichincha.jpg/7f949c27-b185-64d5-aaeb-6cd962119b23?t=1597804884019'
 },
 {
  value: '1002',
  label: 'BANCO POPULAR',
  src: 'https://www.pse.com.co/documents/1176700/1193867/15---Banco-Popular.jpg/a57d709f-32ac-eb3e-4ea7-3f841fed966f?t=1597804884068'
 },
 {
  value: '1065',
  label: 'BANCO SANTANDER COLOMBIA',
  src: 'https://www.pse.com.co/documents/1176700/1193867/17-Banco-Santander.png/03691a7b-b692-f332-5781-8b7b7e5d727f?t=1597804884181'
 },
 {
  value: '1069',
  label: 'BANCO SERFINANZA',
  src: 'https://www.pse.com.co/documents/1176700/1193867/29-Serfinanza.png/298fa9a6-fe23-1f26-1408-dad59f9e9f38?t=1597804884612'
 },
 {
  value: '1007',
  label: 'BANCOLOMBIA',
  src: 'https://www.pse.com.co/documents/1176700/1193852/Bancolombia01-01.png/e983b6e6-3975-cced-cbab-8f9336b2ec81?t=1622765002159'
 },
 {
  value: '1061',
  label: 'BANCOOMEVA S.A.',
  src: 'https://www.pse.com.co/documents/1176700/1193867/1.-Bancoomeva.png/eda99858-b881-a973-9bfa-e84093a3e7c4?t=1597804883370'
 },
 {
  value: '1283',
  label: 'CFA COOPERATIVA FINANCIERA',
  src: 'https://www.pse.com.co/documents/1176700/1193867/CFA.png/bcc83a53-336d-100e-234b-aaaed6d409e6?t=1597804884665'
 },
 {
  value: '1009',
  label: 'CITIBANK',
  src: 'https://www.pse.com.co/documents/1176700/1193867/21-CITI.png/325937e2-76b6-f94c-d904-21b42af2a08d?t=1597804884299'
 },
 {
  value: '1370',
  label: 'COLTEFINANCIERA',
  src: 'https://coltefinanciera.co/wp-content/uploads/2022/04/logo-coltefinanciera-1-1-240x60.png'
 },
 {
  value: '1292',
  label: 'CONFIAR COOPERATIVA FINANCIERA',
  src: 'https://www.pse.com.co/documents/1176700/1193867/22-Confiarcoop.png/b85f4840-214a-ad7e-e186-3510e9c0d823?t=1597804884352'
 },
 {
  value: '1289',
  label: 'COTRAFA',
  src: 'https://www.cotrafa.com.co/sites/default/files/cotrafa.png'
 },
 {
  value: '1551',
  label: 'DAVIPLATA',
  src: 'https://www.pse.com.co/documents/1176700/1193756/Logo_daviplata.png/54714017-abe9-bc90-4225-34bd2f1ef606?t=1622213131984'
 },
 {
  value: '1303',
  label: 'GIROS Y FINANZAS',
  src: 'https://www.pse.com.co/documents/1176700/1193852/BU+LOGO+79+x+46px-02.png/5213cc3d-eb49-2e81-8949-47101800e22f?t=1661974973577'
 },
 {
  value: '1507',
  label: 'NEQUI',
  src: 'https://www.pse.com.co/documents/1176700/1193867/26-Nequi.png/496ad78a-0271-f379-9df8-d954bde71008?t=1597804884507'
 },
 {
  value: '1151',
  label: 'RAPPIPAY',
  src: 'https://www.pse.com.co/documents/1176700/1193867/RappyPay.png/416afa44-1285-9867-9587-0c572a01f6ce?t=1597804883294'
 },
 {
  value: '1019',
  label: 'SCOTIABANK COLPATRIA',
  src: 'https://www.pse.com.co/documents/1176700/1193867/27+-Scotiabank-y-Colpatria.png/12951711-d4d0-6ec5-cb1d-eeadc5384f64?t=1597804884559'
 },
 {
  value: '1637',
  label: 'IRIS',
  src: 'https://www.pse.com.co/documents/1176700/1193852/logo_web_pse_iris.png/0ab8b65e-b425-a5c6-392b-eedaacb797a8?t=1629927593650'
 },
 {
  value: '1291',
  label: 'COOFINEP COOPERATIVA FINANCIERA',
  src: 'https://www.pse.com.co/documents/1176700/1193852/LogoComercialCF-Trans.png/76917f45-efce-0a9c-0c86-8a1a91d364cb?t=1639624601560'
 },
 {
  value: '1070',
  label: 'LULO BANK',
  src: 'https://www.pse.com.co/documents/1176700/1193852/ACH+-+Logo.png/4b0c54a7-2869-e163-2e48-e90f9390424c?t=1664569838122'
 }
];

const PseForm = ({ show, src, register, setValue, errors }) => {
 const { contract } = contextPayment();
 const [entidades] = useState(initialsData);
 const [entidad, setEntidad] = useState(null);

 useEffect(() => {
  if (show)
   setValue('payment_method', {
    type: 'PSE',
    user_type: '', // Tipo de persona, natural (0) o jurídica (1)
    user_legal_id_type: '', // Tipo de documento, CC o NIT
    user_legal_id: '', // Número de documento
    financial_institution_code: '', // Código (`code`) de la institución financiera
    payment_description: contract?.project?.detail
     ? contract?.project?.detail
     : contract?.project?.name?.toLowerCase() + ' ' + contract?._id?.slice(-4) // Descripción de lo que está pagando. Máximo 64 caracteres
   });
 }, [show]);

 return (
  <Collapse in={show} appear>
   <div className="" id="example-collapse-text">
    <Flex className="fs--1 mb-3 d-block d-sm-none" alignItems="center" wrap="wrap">
     <Avatar src={src} size={'4xl'} className="me-3" />
     <div className="flex-1 ps-3 border-start border-start-dark">
      <h5 className="mb-0 text-primary">
       <span className="bg-100 dark__bg-1100 pe-3">PSE</span>
      </h5>
      <span className="bg-100 dark__bg-1100 pe-3">
       Pagos <strong>seguros</strong> en <strong>línea</strong>
      </span>
     </div>
    </Flex>
    <Input
     type="select"
     errors={errors}
     label="Selecciona tu banco"
     name={['payment_method', 'financial_institution_code']}
     placeholder="- Escoge un banco -"
     options={entidades}
     formLabelProps={{ column: true, xs: 12, sm: 6, className: 'text-lg-end' }}
     formColumnProps={{ xs: 12, sm: 6, className: 'text-info' }}
     formGroupProps={{ as: Row, className: 'my-1' }}
     formControlProps={{
      ...register('payment_method.financial_institution_code', { required: 'Debe especificar el banco de su confianza' }),
      maxLength: 30,
      autoComplete: 'off',
      onChange: ({ target: { value /* , name */ } }) => setEntidad(entidades.find(s => s.value === value))
     }}
    />
    <Input
     type="select"
     errors={errors}
     label="Tipo de persona"
     name={['payment_method', 'user_type']}
     placeholder="Tipo de persona"
     options={[
      { label: 'Natural', value: '0' },
      { label: 'Jurídica', value: '1' }
     ]}
     formLabelProps={{ column: true, xs: 6, sm: 7, className: 'text-lg-end' }}
     formColumnProps={{ xs: 6, sm: 5, className: 'text-info' }}
     formGroupProps={{ as: Row, className: 'my-1' }}
     formControlProps={{ ...register('payment_method.user_type', { required: 'Debe elegir el tipo de persona' }) }}
    />
    <Input
     type="select"
     errors={errors}
     label="Tipo de docu."
     name={['payment_method', 'user_legal_id_type']}
     placeholder="Documento"
     options={[
      { label: 'CC', value: 'CC' },
      { label: 'CE', value: 'CE' },
      { label: 'NIT', value: 'NIT' }
     ]}
     formLabelProps={{ column: true, xs: 6, sm: 6, className: 'text-lg-end' }}
     formColumnProps={{ xs: 6, sm: 6, className: 'text-info' }}
     formGroupProps={{ as: Row, className: 'my-1' }}
     formControlProps={{ ...register('payment_method.user_legal_id_type', { required: 'Debe elegir el tipo de documento' }) }}
    />
    <Input
     type="text"
     errors={errors}
     label="Documento*"
     name={['payment_method', 'user_legal_id']}
     placeholder="Documento"
     formLabelProps={{ column: true, xs: 5, sm: 6, className: 'text-lg-end' }}
     formColumnProps={{ xs: 7, sm: 6, className: 'text-info' }}
     formGroupProps={{ as: Row, className: 'my-1' }}
     formControlProps={{
      ...register('payment_method.user_legal_id', { required: 'Debe especificar el nombre que esta en la tajeta' })
     }}
    />

    <Row className="mt-3 pb-1">
     <Col xs={12} className="d-flex justify-content-center">
      <Flex alignItems="center">{entidad && <Image src={entidad.src} thumbnail height="200px" width="200px" />}</Flex>
     </Col>
     <Col xs={12} className="fs--1 mt-4">
      <span className="bg-100 dark__bg-1100 pe-3">
       En breve seras <strong>redirigido a tu entidad financiera</strong>, y hay podras continuar con el <strong>pago</strong>
      </span>
     </Col>
    </Row>
   </div>
  </Collapse>
 );
};

PseForm.propTypes = {
 show: PropTypes.bool.isRequired,
 src: PropTypes.string,
 register: PropTypes.func,
 setValue: PropTypes.func,
 errors: PropTypes.object
};

export default PseForm;
